import { useQuery, type UseQueryResult } from '@/lib/query';
import { getOrganizationBookings } from '@/modules/bookings/api';
import { CompanyBookingDto } from '@cargovibe/shared-types';

export const useOrganizationBookings = (): UseQueryResult<CompanyBookingDto[]> => {
  return useQuery<CompanyBookingDto[]>({
    queryKey: ['organization-bookings'],
    queryFn: getOrganizationBookings,
  });
};
